const cookie = document.querySelector('.cookie');

export function showCookie() {
  if (cookie === null) {
    return;
  }
  setTimeout(() => {
    const closeBtn = cookie.querySelector('.cookie__button');
    cookie.classList.add('active');
    closeBtn.addEventListener('click', closeBtnlickHandler);
  }, 2000);
}

function closeBtnlickHandler() {
  cookie.classList.remove('active');
}
